const AllPackages = [
  {
    name: 'Lit Ultimate',
    speed: '1GB',
    productCode: 'O-LIT-FIBRE-1000',
    bundleCode: 'B-LIT-ULTIMATE-2502-12M',
    contract: '12Months',
  },
  {
    name: 'Lit Gamer',
    speed: '1GB',
    productCode: 'O-LIT-FIBRE-1000',
    bundleCode: 'B-LIT-GAMER-2502-12M',
    contract: '12Months',
  },
  {
    name: 'Lit Homeworker',
    speed: '500Mb',
    productCode: 'O-LIT-FIBRE-500',
    bundleCode: 'B-LIT-HOMEWORKER-2502-12M',
    contract: '12Months',
  },
  {
    name: 'Lit Family',
    speed: '500Mb',
    productCode: 'O-LIT-FIBRE-500',
    bundleCode: 'B-LIT-FAMILY-2502-12M',
    contract: '12Months',
  },
  {
    name: 'Lit One',
    speed: '150MB',
    productCode: 'O-LIT-FIBRE-100',
    bundleCode: 'B-LIT-ONE-U4-2506-12M',
    contract: '12Months',
  },
  //18months
  {
    name: 'Lit Ultimate',
    speed: '1GB',
    productCode: 'O-LIT-FIBRE-1000-18M',
    bundleCode: 'B-LIT-ULTIMATE-2502-18M',
    contract: '18Months',
  },
  {
    name: 'Lit Gamer',
    speed: '1GB',
    productCode: 'O-LIT-FIBRE-1000-18M',
    bundleCode: 'B-LIT-GAMER-2502-18M',
    contract: '18Months',
  },
  {
    name: 'Lit Homeworker',
    speed: '500Mb',
    productCode: 'O-LIT-FIBRE-500-18M',
    bundleCode: 'B-LIT-HOMEWORKER-2502-18M',
    contract: '18Months',
  },
  {
    name: 'Lit Family',
    speed: '500Mb',
    productCode: 'O-LIT-FIBRE-500-18M',
    bundleCode: 'B-LIT-FAMILY-2502-18M',
    contract: '18Months',
  },
  {
    name: 'Lit One',
    speed: '150MB',
    productCode: 'O-LIT-FIBRE-100-18M',
    bundleCode: 'B-LIT-ONE-U4-2506-18M',
    contract: '18Months',
  },
  //24months
  {
    name: 'Lit Ultimate',
    speed: '1GB',
    productCode: 'O-LIT-FIBRE-1000-24M',
    bundleCode: 'B-LIT-ULTIMATE-2502-24M',
    contract: '24Months',
  },
  {
    name: 'Lit Gamer',
    speed: '1GB',
    productCode: 'O-LIT-FIBRE-1000-24M',
    bundleCode: 'B-LIT-GAMER-2502-24M',
    contract: '24Months',
  },

  {
    name: 'Lit Homeworker',
    speed: '500Mb',
    productCode: 'O-LIT-FIBRE-500-24M',
    bundleCode: 'B-LIT-HOMEWORKER-2502-24M',
    contract: '24Months',
  },
  {
    name: 'Lit Family',
    speed: '500Mb',
    productCode: 'O-LIT-FIBRE-500-24M',
    bundleCode: 'B-LIT-FAMILY-2502-24M',
    contract: '24Months',
  },
  {
    name: 'Lit One',
    speed: '150MB',
    productCode: 'O-LIT-FIBRE-100-24M',
    bundleCode: 'B-LIT-ONE-U4-2506-24M',
    contract: '24Months',
  },
  //business 12months
  {
    name: 'Lit Business Ultimate',
    speed: '1GB',
    productCode: 'O-LIT-BIZ-1000-12M',
    bundleCode: 'B-LIT-BIZ-ULTIMATE-2508-12M',
    contract: '12Months',
  },
  {
    name: 'Lit Business Pro',
    speed: '500Mb',
    productCode: 'O-LIT-BIZ-500-12M',
    bundleCode: 'B-LIT-BIZ-PRO-2508-12M',
    contract: '12Months',
  },
  {
    name: 'Lit Business Basic',
    speed: '150MB',
    productCode: 'O-LIT-BIZ-150-12M',
    bundleCode: 'B-LIT-BIZ-BASIC-2508-12M',
    contract: '12Months',
  },
  //24months
  {
    name: 'Lit Business Ultimate',
    speed: '1GB',
    productCode: 'O-LIT-BIZ-1000-24M',
    bundleCode: 'B-LIT-BIZ-ULTIMATE-2508-24M',
    contract: '24Months',
  },
  {
    name: 'Lit Business Pro',
    speed: '500Mb',
    productCode: 'O-LIT-BIZ-500-24M',
    bundleCode: 'B-LIT-BIZ-PRO-2508-24M',
    contract: '24Months',
  },
  {
    name: 'Lit Business Basic',
    speed: '150MB',
    productCode: 'O-LIT-BIZ-150-24M',
    bundleCode: 'B-LIT-BIZ-BASIC-2508-24M',
    contract: '24Months',
  },
  //36months
  {
    name: 'Lit Business Ultimate',
    speed: '1GB',
    productCode: 'O-LIT-BIZ-1000-36M',
    bundleCode: 'B-LIT-BIZ-ULTIMATE-2508-36M',
    contract: '36Months',
  },
  {
    name: 'Lit Business Pro',
    speed: '500Mb',
    productCode: 'O-LIT-BIZ-500-36M',
    bundleCode: 'B-LIT-BIZ-PRO-2508-36M',
    contract: '36Months',
  },
  {
    name: 'Lit Business Basic',
    speed: '150MB',
    productCode: 'O-LIT-BIZ-150-36M',
    bundleCode: 'B-LIT-BIZ-BASIC-2508-36M',
    contract: '36Months',
  },
];

const ValidContracts = [
  {
    id: '36Months',
    length: 36,
    title: '36 Months',
  },
  {
    id: '24Months',
    length: 24,
    title: '24 Months',
  },
  {
    id: '18Months',
    length: 18,
    title: '18 Months',
  },
  {
    id: '12Months',
    length: 12,
    title: '12 Months',
  },
];

exports.AllPackages = AllPackages;
exports.ValidContracts = ValidContracts;
